import React from 'react';
import { Plus, Trash2 } from 'lucide-react';

export function PageNavigator({
  pageThumbnails, activePageIndex, onPageChange, onAddPage, onDeletePage,
  pages, pageW, pageH,
  headerConfig, footerConfig, headerH, footerH,
}) {
  return (
    <div className="w-44 border-r border-border/30 bg-muted/10 flex flex-col flex-shrink-0" data-testid="page-navigator">
      <div className="px-2 py-2 border-b border-border/20">
        <span className="text-[9px] font-semibold text-muted-foreground uppercase tracking-wider">Pages</span>
      </div>
      <div className="flex-1 overflow-y-auto p-2 space-y-2">
        {pageThumbnails.map((thumb, idx) => (
          <button
            key={thumb.id}
            onClick={() => onPageChange && onPageChange(idx)}
            className={`w-full rounded-lg border-2 transition-all group relative ${idx === activePageIndex ? 'border-primary shadow-lg shadow-primary/20' : 'border-border/30 hover:border-primary/40'}`}
            data-testid={`page-thumb-${idx}`}
          >
            <div className="bg-white rounded-md mx-1 mt-1 relative overflow-hidden" style={{ aspectRatio: `${pageW} / ${pageH}`, maxHeight: 120 }}>
              {headerConfig?.enabled && (
                <div className="absolute left-0 right-0 top-0 bg-sky-100/50 border-b border-sky-200/30" style={{ height: `${(headerH / pageH) * 100}%` }} />
              )}
              {footerConfig?.enabled && (
                <div className="absolute left-0 right-0 bottom-0 bg-sky-100/50 border-t border-sky-200/30" style={{ height: `${(footerH / pageH) * 100}%` }} />
              )}
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="text-lg font-bold text-gray-300">{idx + 1}</span>
              </div>
              {thumb.hasPageBreak && <div className="absolute top-0 left-0 right-0 h-1 bg-amber-400" title="Manual page break" />}
            </div>
            <div className="px-1.5 py-1 flex items-center justify-between">
              <span className={`text-[9px] truncate ${idx === activePageIndex ? 'text-primary font-medium' : 'text-muted-foreground'}`}>{thumb.name}</span>
              {pages.length > 1 && (
                <button onClick={(e) => { e.stopPropagation(); onDeletePage && onDeletePage(idx); }} className="opacity-0 group-hover:opacity-100 p-0.5 rounded hover:bg-destructive/20 text-muted-foreground hover:text-destructive transition-opacity" title="Delete page">
                  <Trash2 className="w-2.5 h-2.5" />
                </button>
              )}
            </div>
          </button>
        ))}
        <button onClick={onAddPage} className="w-full py-3 rounded-lg border-2 border-dashed border-border/40 hover:border-primary/40 hover:bg-primary/5 transition-colors flex items-center justify-center gap-1 text-muted-foreground hover:text-primary" data-testid="add-page-btn">
          <Plus className="w-3 h-3" />
          <span className="text-[9px]">Add Page</span>
        </button>
      </div>
    </div>
  );
}
